import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { SpinnerComponent } from './views/layout/spinner/spinner.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'TCT';
  spinnerComponent = SpinnerComponent;
  public validinput: RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/incomereport' || e.url === '/refuelreport'
        || e.url === '/distancereport' || e.url === '/tripreport' 
        || e.url === '/tripstatusreport' || e.url === '/podturnaround'
          || e.url.startsWith('/users/')
          || e.url.startsWith('/dashboard')
        ) {
          document.body.classList.add('removeglobalfilter');
        } else {
          document.body.classList.remove('removeglobalfilter');
        }
      }
    });
  }

  clearAllData() {
  }

}
